import { Col, ColProps } from 'antd';

interface ColSizeProps {
  children: React.ReactNode;
  className?: string;
  colProps?: ColProps;
  size: 100 | 95 | 85 | 80 | 75 | 50 | 40 | 25 | 20 | 10 | 9 | 8;
}

export const ColSize = ({
  children,
  className,
  colProps,
  size,
}: ColSizeProps) => {
  const sizeMap = {
    100: 24,
    95: 23,
    85: 21,
    80: 20,
    75: 16,
    50: 12,
    40: 9,
    25: 8,
    20: 6,
    10: 4,
    9 : 3,
    8 : 2, 
  };

  const span = sizeMap[size];

  return (
    <Col
      lg={{ span }}
      md={{ span }}
      sm={{ span: 24 }}
      xl={{ span }}
      xs={{ span: 24 }}
      style={{ ...colProps?.style }}
      className={className}
      {...colProps}
    >
      {children}
    </Col>
  );
};
